import { render, staticRenderFns } from "./TaskDesc.vue?vue&type=template&id=501e1452&"
import script from "./TaskDesc.vue?vue&type=script&lang=js&"
export * from "./TaskDesc.vue?vue&type=script&lang=js&"
import style0 from "./TaskDesc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports